export const AnalyticsTool = Object.freeze({
	booking: 'booking',
});

export const AnalyticsCategory = Object.freeze({
	booking: 'booking',
	waitlist: 'waitlist',
});

export const AnalyticsEvent = Object.freeze({
	showPopup: 'show_popup',
	clickAddResource: 'click_add_resource',
	addResourceStep1: 'add_resource_step1',
	addResourceStep2: 'add_resource_step2',
	addResourceFinish: 'add_resource_finish',
	acceptAgreement: 'accept_agreement',
});

export const AnalyticsType = Object.freeze({
	showPopup: 'show_popup',
	clickAddResource: 'click_add_resource',
});

export const AnalyticsCSection = Object.freeze({
	booking: 'booking',
	crm: 'crm',
	mainMenu: 'main_menu',
});

export const AnalyticsElement = Object.freeze({
	addButton: 'add_button',
});

export const AnalyticsCSubSection = Object.freeze({
	accept: 'accept',
	deny: 'deny',
});
